import { useEffect } from "@wordpress/element";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "vino/core";
import { bookEvent } from "store/vino/eventBookingSlice";
import PaymentMethodCard from "vino/components/cart-checkout/PaymentMethodCard";
import {
	PaymentCardSchema,
	PaymentMethodDefaultValues,
} from "vino/components/cart-checkout/models";
import OrderSummary from "./OrderSummary";

const PaymentMethodOptions = ({ onBack }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const eventBooking = useSelector(({ vino }) => vino.eventBooking);
	const user = useSelector(({ auth }) => auth.user);
	const { isSubmitting, payment } = eventBooking;
	const methods = useForm({
		mode: "onChange",
		defaultValues: { card: PaymentMethodDefaultValues },
		resolver: yupResolver(PaymentCardSchema),
	});

	const { handleSubmit, reset } = methods;

	useEffect(() => {
		if (payment) {
			reset(payment);
		}
	}, [payment, reset]);

	const onSubmit = (paymentMethod) => {
		const model = {
			eventInformation: eventBooking.eventInformation,
			package: eventBooking.package,
			customer: eventBooking.customer,
			paymentMethod,
		};
		dispatch(
			bookEvent({
				model,
				user,
				navigate,
			})
		);
	};

	return (
		<Paper className="w-full rounded-20 shadow flex flex-wrap">
			<div className="flex-1 w-3/5">
				<FormProvider {...methods}>
					<form
						noValidate
						className="flex flex-col w-full"
						onSubmit={handleSubmit(onSubmit)}
					>
						<div className="flex items-center p-20">
							<Typography className="text-16 font-medium">Payment</Typography>
						</div>
						<div className="w-full px-20">
							<Typography className="text-16">Credit Card</Typography>
							<div className="mt-10">
								<PaymentMethodCard />
							</div>
						</div>
						<Divider className="my-10" />
						<div className="w-full p-20">
							<div className="flex justify-between">
								<Button onClick={onBack}>
									<i className="fa-solid fa-angle-left mr-5"></i> Back
								</Button>
								<Button isSubmitting={isSubmitting} type="submit">
									Place Order
								</Button>
							</div>
						</div>
					</form>
				</FormProvider>
			</div>
			<div className="w-2/5">
				<OrderSummary title="Order summary" />
			</div>
		</Paper>
	);
};

export default PaymentMethodOptions;
